export default "__VITE_ASSET__DojMeMiE__"